module.exports = __webpack_public_path__ + "img/tj.18657b24.svg";